import angular from 'angular';
import 'angular-ui-router';
import 'angular-sanitize';
import 'angular-resource';
import 'angular-cookies';
import bcrypt from './services/bcrypt';
import lbServicesGreenback from './services/lbServices/lb-services-greenback.js';
import lbServicesAdvertising from './services/lbServices/lb-services-advertising.js';
import sharedServices from './services/app.sharedservices.js';
import AccountService from './services/account.service.js';
import 'config';
import appConfig from './config/app.config';
import appRun from './config/app.run';
import mainScss from './../scss/application.scss';
import "babel-polyfill";

import 'bootstrap-loader';
import 'slick-carousel';

import { containersModule } from './containers';

const requires = [
  'ui.router',
  'ngResource',
  'ngSanitize',
  'ngCookies',
  'config',
  'lbServicesGreenback',
  'lbServicesAdvertising',
  'com.module.sharedservices',
  containersModule.name,
  'dtrw.bcrypt'
];

const app = angular.module('app', requires);
app.config(appConfig);
app.run(appRun);

angular.element(document).ready(() => {
  angular.bootstrap(document.body, [app.name], {
    strictDi: true,
  });
});



// WEBPACK FOOTER //
// ./js/app.js